import React, { useEffect } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper';
//import GetAllFormFields from '../../../../components/_utils/formUtils'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import moment from 'moment'
import {
    Button,
    Card,
    Col,
    DatePicker,
    Form,
    Icon,
    Input,
    InputNumber,
    List,
    notification,
    Popconfirm,
    Row,
    Select,
    Table,
    Tabs,
    Tag,
    Tooltip,
    Upload
} from 'antd'
import styles from '../../../components/_utils/masterDoc.less'
import { hideLoader, showLoader } from '../../../modules/actions'
import _ from 'lodash'
import Request, { API_URL, LAPI_URL, MEDIA_URL } from '../../../request'
import { connect } from 'react-redux'

const Option = Select.Option
const { TextArea } = Input
const TabPane = Tabs.TabPane;
let knowledgeBaseId = '';

@Form.create()
class AddKnowledge extends React.Component {
    state = {
        loading: false,
        arr: [],
        link: '',
        title: '',
        description: '',
        editIndex: null,
        links: [],
        fileDescription: '',
        fileTitle: '',
        mediaId: null,
        files: [],
        arr: [],
        inputTypes: {
            fields: [
                {
                    label: 'Country',
                    key: 'countryId',
                    required: true,
                    showSearch: true,
                    allowClear: true,
                    placeholder: 'Select Country',
                    type: 'select',
                    disabled: false,
                    options: [],
                    onChange: val => {
                        this.props.form.setFieldsValue({
                            countryId: val,
                            universityId: ''
                        })
                        this.loadUniversities(val);
                    }
                },
                {
                    label: 'University',
                    key: 'universityId',
                    required: false,
                    showSearch: true,
                    allowClear: true,
                    placeholder: 'Select University',
                    type: 'select',
                    disabled: false,
                    options: [],
                    onChange: val => {
                        this.props.form.setFieldsValue({
                            universityId: val
                        })
                    }
                },
                {
                    label: 'Category',
                    key: 'knowledgeBaseCategoryId',
                    required: true,
                    showSearch: true,
                    allowClear: true,
                    placeholder: 'Select Category',
                    type: 'select',
                    disabled: false,
                    options: [],
                    onChange: val => {
                        this.props.form.setFieldsValue({
                            knowledgeBaseCategoryId: val
                        })
                    }
                },
            ]
        }
    }
    constructor(props) {
        super(props)
        this.loadAllCountries();
        this.loadKnowledgeBaseCategory();
    }

    handleSubmit = e => {
        const { dispatch, form } = this.props;
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                values.links = this.state.links;
                if (!values.universityId) {
                    delete values.universityId;
                }
                if (knowledgeBaseId) {
                    values = { ...values, _id: knowledgeBaseId }

                    dispatch(showLoader())

                    let x = await Request.updateKnowledgeBase(values)
                    dispatch(hideLoader())

                    if (!x.error) {
                        notification.success({
                            message: 'Success',
                            description: x.msg
                        })
                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.msg
                        })
                    }
                } else {
                    dispatch(showLoader())
                    dispatch(hideLoader())
                    let x = await Request.addKnowledgeBase(values)

                    dispatch(hideLoader())

                    if (!x.error) {
                        notification.success({
                            message: 'Success',
                            description: x.msg
                        })

                        form.resetFields()
                        this.setState({
                            links: []
                        })
                        knowledgeBaseId = x.data._id;
                        this.setFormValues(knowledgeBaseId)
                        window.history.pushState("", "", `/add-knowledge-base?id=${knowledgeBaseId}`);
                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.msg
                        })
                    }
                }
            }
        })
    }

    setFormValues = async knowledgeBaseId => {


        try {
            let { doc } = await Request.getKnowledgeBase(knowledgeBaseId)
            if (doc) {
                if (doc.countryId) {
                    this.loadUniversities(doc.countryId);
                }
                if (doc.links && doc.links.length > 0) {
                    this.setState({ links: doc.links })
                }
                if (doc.mediaFiles && doc.mediaFiles.length > 0) {
                    _.each(doc.mediaFiles, (item) => {
                        _.each(item.files, val => {
                            item.link = MEDIA_URL + val.url
                            item.name = val.name
                        })
                    })
                }

                let tempObj = {}

                let inputTypes = this.state.inputTypes

                _.each(inputTypes.fields, (v, k) => {
                    tempObj[v.key] = doc[v.key]
                })

                this.props.form.setFieldsValue(tempObj)

                this.setState({ arr: doc.mediaFiles }, () => {
                })

            }
        } catch (e) {
            console.log(e)
        }
    }

    componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search)
        knowledgeBaseId = searchParams.get('id')

        if (knowledgeBaseId) {
            this.setFormValues(knowledgeBaseId)
        }

        setTimeout(() => {
        }, 2000)
    }

    loadUniversities = async (countryId) => {
        Request.loadSimpleUniversitiesByCountry({
            universityCountryId: countryId,
            sort: { universityInstitutionName: 1 }
        })
            .then(resp => {
                resp.arr = resp.arr.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.universityInstitutionName })
                    return temp
                }, [])


                let inputTypes = this.state.inputTypes
                inputTypes['fields'][1].options = resp.arr
                this.setState({ inputTypes: inputTypes })


            })
            .catch(err => {
                console.log(err)
            })
    }

    loadAllCountries = () => {
        let params = {
            results: 100,
            sortField: 'countryName',
            sortOrder: 'ascend'
        }
        Request.getCountriesWithoutAuth(params)
            .then(resp => {
                if (resp) {
                    resp.data = resp.data.reduce((temp, vv) => {
                        vv.display = vv.countryName
                        vv.id = vv._id
                        temp.push(vv)
                        return temp
                    }, [])

                    let inputTypes = this.state.inputTypes
                    inputTypes['fields'][0].options = resp.data
                    this.setState({ inputTypes: inputTypes })

                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    loadKnowledgeBaseCategory = async () => {
        Request.loadKnowledgeBaseCategory({ sortField: 'name', results: 1100 })
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.name })
                    return temp
                }, [])

                let inputTypes = this.state.inputTypes
                inputTypes['fields'][2].options = resp.data
                this.setState({ inputTypes: inputTypes })

            })
            .catch(err => {
                console.log(err)
            })
    }

    loadDocs = () => {
        this.setFormValues(knowledgeBaseId)
    }

    addToIntake = () => {
        if (!this.state.link || !this.state.title) {
            notification.error({
                message: 'Error',
                description: 'Title & Link is required'
            })
            return false;
        }
        let tempArr = this.state.links
        tempArr.push({
            link: this.state.link,
            title: this.state.title,
            description: this.state.description
        })
        this.setState({ links: tempArr, link: null, title: null, description: null })
    }
    editIntake = (row, index) => {
        this.setState({ link: row.link, title: row.title, description: row.description, editIndex: index })
    }
    updateIntake = () => {
        if (!this.state.link || !this.state.title) {
            notification.error({
                message: 'Error',
                description: 'Title & Link is required'
            })
            return false;
        }
        let { editIndex, link, title, description } = this.state;
        let tempArr = this.state.links;
        tempArr[editIndex] = {
            link: link,
            title: title,
            description: description
        };
        this.setState({ links: tempArr, link: null, title: null, description: null, editIndex: null })
    }
    removeIn = sss => {
        let arr = this.state.links
        arr = _.reject(arr, val => {
            return val.title == sss
        })
        this.setState({ links: arr })
    }

    handleChange = v => {
        if (v.fileList) {
            this.setState({ files: v.fileList })
        }
    }

    onRemove = v => {
        console.log(v)
    }

    saveFiles = () => {
        const { dispatch, form } = this.props
        let { files, fileDescription, fileTitle } = this.state;
        if (!fileTitle) {
            return notification.error({ message: 'Title is required' })
        }
        if (!fileDescription) {
            return notification.error({ message: 'Description is required' })
        }
        if (!files.length) {
            return notification.error({ message: 'Expect file' })
        }
        let obj = {
            _id: knowledgeBaseId,
            fileDescription: fileDescription,
            fileTitle: fileTitle,
            files: files
        }

        Request.addKnowledgeBaseFile(obj)
            .then(resp => {
                if (resp.success) {
                    this.loadDocs()
                    this.setState({
                        fileTitle: '',
                        fileDescription: '',
                        files: [],
                        file: ''
                    })
                    this.onRemove()
                    return notification.success({
                        message: 'Success',
                        description: resp.msg
                    })
                }
                if (resp.error) {
                    return notification.error({ message: 'Error', description: resp.msg })
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    handleDelete = (val) => {
        let obj = {
            knowledgeBaseId: knowledgeBaseId,
            mediaId: val
        }

        Request.deleteKnowledgeBaseMediaFiles(obj)
            .then(x => {
                if (x.success) {
                    this.loadDocs()
                    return notification.success({
                        message: x.msg
                    })

                } else {
                    return notification.error({ message: 'Error', description: x.msg })
                }
            })
            .catch(err => {
                notification.error({
                    message: 'Error',
                    description: 'Some Error'
                })
            })
    }

    handleEdit = (item) => {

        this.setState({
            fileTitle: (item.fileTitle != undefined ? item.fileTitle : ''),
            fileDescription: item.fileDescription,
            files: item.files,
            mediaId: item._id
        })
    }

    updateFiles = () => {
        const { dispatch, form } = this.props
        let { files, fileDescription, fileTitle, mediaId } = this.state;
        if (!fileTitle) {
            return notification.error({ message: 'Title is required' })
        }
        if (!fileDescription) {
            return notification.error({ message: 'Description is required' })
        }
        if (!files.length) {
            return notification.error({ message: 'Expect file' })
        }
        let obj = {
            knowledgeBaseId: knowledgeBaseId,
            fileDescription: fileDescription,
            fileTitle: fileTitle,
            files: files,
            mediaId: mediaId
        }
        Request.updateKnowledgeBaseFile(obj)
            .then(resp => {
                if (resp.success) {
                    this.loadDocs()
                    this.setState({
                        fileTitle: '',
                        fileDescription: '',
                        files: [],
                        file: '',
                        mediaId: null
                    })
                    this.onRemove()
                    return notification.success({
                        message: 'Success',
                        description: resp.msg
                    })
                }
                if (resp.error) {
                    return notification.error({ message: 'Error', description: resp.msg })
                }
            })
            .catch(err => {
                console.log(err)
            })
    }


    render() {
        const {
            form: { getFieldDecorator, getFieldValue, setFieldsValue }
        } = this.props;

        const { title, description, link, links, inputTypes, mediaId } = this.state;


        return (
            <PageHeaderWrapper title={knowledgeBaseId ? 'Edit Knowledge Base' : 'Add Knowledge Base'}>
                <Card bordered={true}>
                    <Tabs onChange={this.callback} type="card">
                        <TabPane tab={'General Info'} key={0}>
                            <div style={{ padding: 20 }}>

                                <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>

                                    <GetAllFormFields
                                        inputSchema={inputTypes}
                                        loading={this.props.loading}
                                        getFieldDecorator={getFieldDecorator}
                                    />

                                    <Row className='' style={{ padding: '10px 305px 20px' }}>

                                        <Col span={24}>
                                            <Row>
                                                <Col span={4}>
                                                    <h4>Video Links: </h4>
                                                </Col>
                                                <Col span={16} >

                                                    <Input
                                                        value={title}
                                                        placeholder={'Enter Title'}
                                                        className={'knowledge-base-input'}
                                                        onChange={ei => {
                                                            this.setState({
                                                                title: ei.target.value
                                                            })
                                                        }}
                                                    />
                                                    <TextArea
                                                        rows="5"
                                                        value={description}
                                                        placeholder={'Enter Description'}
                                                        className={'knowledge-base-input'}
                                                        onChange={ei => {
                                                            this.setState({
                                                                description: ei.target.value
                                                            })
                                                        }}
                                                    />
                                                    <Input
                                                        value={link}
                                                        placeholder={'Enter Link'}
                                                        className={'knowledge-base-input'}
                                                        onChange={ei => {
                                                            this.setState({
                                                                link: ei.target.value
                                                            })
                                                        }}
                                                    />
                                                </Col>
                                                <Col span={4} style={{ paddingLeft: 10 }}>
                                                    {
                                                        this.state.editIndex != null ?
                                                            <Button
                                                                onClick={this.updateIntake}>
                                                                Update LINKS
                                                            </Button>
                                                            :
                                                            <Button
                                                                onClick={this.addToIntake}>
                                                                ADD TO LINKS
                                                            </Button>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row style={{ marginLeft: 74 }}>
                                                <Col span={24}>
                                                    <List
                                                        size="small"
                                                        header={<div>Saved Links</div>}
                                                        bordered
                                                        dataSource={links}
                                                        renderItem={(val, index) => (
                                                            <List.Item>
                                                                <Row style={{ width: '100%' }}>
                                                                    <Col span={20}>
                                                                        {val.title} <br />
                                                                        {val.description} <br />
                                                                        {val.link}
                                                                    </Col>
                                                                    <Col span={4}>
                                                                        <a
                                                                            onClick={() =>
                                                                                this.editIntake(val, index)
                                                                            }>
                                                                            Edit
                                                                        </a>
                                                                        <br />
                                                                        <a
                                                                            onClick={() =>
                                                                                this.removeIn(val.title)
                                                                            }>
                                                                            Remove
                                                                        </a>
                                                                    </Col>
                                                                </Row>
                                                            </List.Item>
                                                        )}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                    <div style={{ textAlign: 'center' }}>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            loading={this.props.loading}>
                                            SAVE
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </TabPane>
                        <TabPane tab={`Files to Library `} key={1} >
                            {knowledgeBaseId ? (<Card>
                                <Row>
                                    <Col span={12}>
                                        <Card title="Add Document">

                                            <div className="gutter-example">
                                                <Row gutter={16} className={styles['margin-t-md']}>
                                                    <Col className="gutter-row" span={6}>
                                                        <div className="gutter-box">Title</div>
                                                    </Col>
                                                    <Col className="gutter-row" span={18}>
                                                        <div className="gutter-box">
                                                            <Input
                                                                placeholder="Title"
                                                                value={this.state.fileTitle}
                                                                onChange={e => {
                                                                    this.setState({ fileTitle: e.target.value })
                                                                }}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>

                                            <div className="gutter-example">
                                                <Row gutter={16} className={styles['margin-t-md']}>
                                                    <Col className="gutter-row" span={6}>
                                                        <div className="gutter-box">Description</div>
                                                    </Col>
                                                    <Col className="gutter-row" span={18}>
                                                        <div className="gutter-box">
                                                            <TextArea
                                                                rows="5"
                                                                placeholder="Description"
                                                                value={this.state.fileDescription}
                                                                onChange={e => {
                                                                    this.setState({ fileDescription: e.target.value })
                                                                }}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>

                                            <div className="gutter-example">
                                                <Row gutter={16} className={styles['margin-t-md']}>
                                                    <Col className="gutter-row" span={6}>
                                                        <div className="gutter-box">File</div>
                                                    </Col>
                                                    <Col className="gutter-row" span={18}>
                                                        <div className="gutter-box">
                                                            <Upload
                                                                name={'file'}
                                                                fileList={this.state.files}
                                                                action={`${LAPI_URL}/filesUploader`}
                                                                onChange={this.handleChange}
                                                                onRemove={this.onRemove}>
                                                                <Button>
                                                                    <Icon type="upload" /> Select File
                                                                </Button>
                                                            </Upload>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="gutter-example">
                                                <Row gutter={16} className={styles['margin-t-md']}>
                                                    <Col className="gutter-row" span={6} />
                                                    <Col className="gutter-row" span={6}>
                                                        {
                                                            mediaId ?
                                                                <Button type="primary" onClick={this.updateFiles}>
                                                                    Upload Now
                                                                </Button>
                                                                :
                                                                <Button type="primary" onClick={this.saveFiles}>
                                                                    Upload Now
                                                                </Button>
                                                        }
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Card>
                                    </Col>
                                    <Col span={12}>
                                        <Card title="Previous Documents">
                                            <List
                                                className={styles['demo-loadmore-list']}
                                                size="small"
                                                header={<div>Total : {this.state.arr.length}</div>}
                                                bordered
                                                dataSource={this.state.arr || []}
                                                renderItem={item => (
                                                    <List.Item key={item.id}>
                                                        <List.Item.Meta
                                                            title={
                                                                <a
                                                                    href={item.link}
                                                                    style={{
                                                                        color: 'orange',
                                                                        textDecorationLine: 'underline'
                                                                    }}
                                                                    target={'_blank'}>
                                                                    {item.name}
                                                                </a>
                                                            }
                                                            description={
                                                                <div style={{ fontSize: 13 }}>
                                                                    {item.fileTitle}<br></br>
                                                                    {item.fileDescription}<br></br>
                                                                    <div>{item.uploadedBy && `${moment(item.uploadedBy.time).format('Do MMMM, YYYY')} [${moment(item.uploadedBy.time).format('hh:mm')}]`}</div>
                                                                    <div>{item.uploadedBy && `[${item.uploadedBy.name}]`}</div>
                                                                </div>

                                                            }
                                                        />

                                                        <div>
                                                            <Tooltip title="Edit">
                                                                <Button
                                                                    style={{ marginLeft: '5px' }}
                                                                    onClick={() => this.handleEdit(item)}
                                                                    size={'small'}
                                                                    shape="circle"
                                                                    icon="edit" />
                                                            </Tooltip>
                                                            <Tooltip title="Delete">
                                                                <Popconfirm
                                                                    title="Are you sure to delete?"
                                                                    onConfirm={() => this.handleDelete(item._id)}>
                                                                    <Button
                                                                        style={{ marginLeft: '5px' }}
                                                                        size={'small'}
                                                                        shape="circle"
                                                                        icon="delete" />
                                                                </Popconfirm>
                                                            </Tooltip>
                                                        </div>
                                                    </List.Item>
                                                )}
                                            />
                                        </Card>
                                    </Col>
                                </Row>
                            </Card>) : <Card><h3>Knowledge must be saved before uploading a file</h3></Card>}

                        </TabPane>
                    </Tabs>
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddKnowledge)
